
define('text!templates/modules/template/custom/custom-content.html',[],function () { return '<div class="panel-body custom-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="alert-no-data"></div>\n    <div class="custom-template-list"></div>\n</div>\n';});

